import { action } from 'easy-peasy';
import { IActionSetAiModels } from '../types';

const setAiModels: IActionSetAiModels = action((state, aiModels) => {
  if (aiModels) {
    state.aiModels = aiModels;
  }
});

export default setAiModels;
